import { ContractDurationType, type EditContractDuration } from "../../../../../autogen/bff-api";

export const buildDurationUpdate = (form: {
  startDate: string | null;
  endDate: string | null;
  isOpenEnded: boolean;
}): EditContractDuration | undefined => {
  if (form.isOpenEnded) return { type: ContractDurationType.OpenEnded };
  if (form.startDate && form.endDate) {
    return { type: ContractDurationType.FixedDates, startDate: form.startDate, endDate: form.endDate };
  }
  return undefined;
};
